import '@/utils/ta-landing.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import packageJson from '../package.json'

// 客户端 log 通道（先挂 window，供 cookie / Client 使用）
import '@/utils/client-log.js'

// 全局方法
import Client from '@/commonFunc/client'
import GlobalMixins from '@/commonFunc/global-mixin'

// 全局组件
import VueClipBoard from 'vue-clipboard2'
import TransformSpecialCodeComp from '@/components/TransformSpecialCode/index.vue'
import NoData from '@/components/NoData/nodata.vue'
import CTipPopover from '@/components/CTipPopover/index.vue'

// 调试日志
import VConsole from 'vconsole'

import * as filters from '@/hooks/base.filter.js'
import * as Sentry from '@sentry/vue'

// 移动端适配 && 埋点
import '@/utils/flexible.debug.js'
import '@/utils/flexible-css.debug.js'
import '@/utils/ta-init.js'

import '@/assets/style/index.scss'
import '@/assets/text/action.css'

import { i18n, loadLanguage, setHtmlDir } from '@/lang/index.js'
import { loadBaseIcon } from '@/assets/packageAssets/packages/index.js'
import { loadWords } from '@/assets/packageAssets/words/index.js'
import { mockLangType, mockApp, mockFlag } from '@/commonFunc/judge-package-name.js'

import {
  Circle,
  DatetimePicker,
  Dialog,
  Field,
  Icon,
  Image as VanImage,
  Lazyload,
  List,
  Loading,
  NavBar,
  Picker,
  Popover,
  Popup,
  Progress,
  Steps,
  Step,
  Stepper,
  Swipe,
  SwipeItem,
  Tabs,
  Tab,
  Uploader,
} from 'vant'

Vue.component('MyPLabel', TransformSpecialCodeComp)
Vue.component('NoData', NoData)
Vue.component('CTipPopover', CTipPopover)

// vant
Vue.use(Circle)
Vue.use(DatetimePicker)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Icon)
Vue.use(VanImage)
Vue.use(Lazyload, { lazyComponent: true })
Vue.use(List)
Vue.use(Loading)
Vue.use(NavBar)
Vue.use(Picker)
Vue.use(Popover)
Vue.use(Popup)
Vue.use(Progress)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Stepper)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Uploader)

// vue-clipboard
Vue.use(VueClipBoard)

// filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.mixin(GlobalMixins)

Vue.config.productionTip = false

Vue.prototype.$client = Client

Vue.prototype.$sentry = Sentry

window.$client = Client

// 测试环境
if (process.env.VUE_APP_IS_RELEASE === '0') {
  new VConsole()
}

// 正式环境
if (process.env.VUE_APP_IS_RELEASE === '1') {
  try {
    Sentry.init({
      Vue,
      dsn: 'https://64e5bce043ce5ef0af2b3fa8683c39e7@sentry.goparty.tech/12',
      release: `${process.env.NODE_ENV}@${packageJson.version}`,
      dist: process.env.VUE_APP_BUILD_DIST || 'dist-default',
      sendDefaultPii: true,
      sampleRate: 0.8,
      environment: process.env.NODE_ENV,
      // 过滤 vue-router 重复导航等噪音错误
      beforeSend(event) {
        const errValue = event?.exception?.values?.[0]?.value || ''
        const noisyPatterns = ['NavigationDuplicated', 'Avoided redundant navigation']
        if (noisyPatterns.some((p) => errValue.includes(p))) {
          return null
        }
        return event
      },
    })
  } catch (err) {
    console.log('try catch err:', err)
  }
}

const useMock = mockFlag
const mockLang = mockLangType
const mockPkg = mockApp

;(async () => {
  // 按需加载语言
  let clientLang = Client.getAppInfoLang() || 'en'
  if (useMock) {
    clientLang = mockLang
  }
  console.log('🚀 ~ initLang:', clientLang)
  await loadLanguage(clientLang)
  setHtmlDir(clientLang)

  // 按需加载分包基础图标 & words
  let appShortName = Client.getPackageShortName() || 'vava'
  if (useMock) {
    appShortName = mockPkg
  }
  console.log('🚀 ~ appShortName:', appShortName)
  await Promise.all([loadBaseIcon(appShortName), loadWords(appShortName)])

  // 挂载应用
  new Vue({
    router,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
})()
